module.exports = __webpack_public_path__ + "static/media/WEB18.3af3169b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/WEB18.jpg
// module id = 88
// module chunks = 0